import { useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";

import { AuthContext } from "@/contexts/AuthContext";
import { GlobalContext } from "@/contexts/GlobalContext";

import useFetch from "@/hooks/useFetchData";

import { Admin } from "@/types/Admin.types";

const AuthenticateAdmin = () => {
    const { globalState: { apiUrl } } = useContext(GlobalContext);
    const { dispatchAuth } = useContext(AuthContext);
    const router = useRouter();
    const { useFetchData } = useFetch();

    const [redirect, setRedirect] = useState<boolean>(false);

    useEffect(() => {
        if (redirect && (router.pathname.match(/admin/) && router.pathname !== "/admin/login")) {
            window.location.href = "/admin/login";
        }
    }, [redirect, router.pathname]);

    const authAdmin = async () => {
        const url: string = apiUrl + "/admin/authenticate";

        try {
          const result = await useFetchData<Admin>(url);

          if (!result.success) {
              dispatchAuth({type: "SET_ADMIN_AUTH", isAdminAuth: false});
              dispatchAuth({ type: "SET_ADMIN", admin: null });
              localStorage.removeItem("__gaat");
              setRedirect(true);

              return false;
          }
    
          dispatchAuth({type: "SET_ADMIN_AUTH", isAdminAuth: true});
          dispatchAuth({ type: "SET_ADMIN", admin: result.data });
          localStorage.setItem("__gaat", JSON.stringify(true));

          return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    };

    return {
        authAdmin
    };
};

export default AuthenticateAdmin;
